import { FC } from 'react';
import {
  MinusCircleOutlined,
  PlusOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { Button, Form, Input, Upload } from 'antd';
import cn from 'classnames';
import { ClientPhoneData } from '../../../models/RoboCall/ClientPhoneData';
import { updloadTasks } from '../../../store/reducers/CampaignSlice';
import { useAppDispatch } from '../../../store/store';
import styles from './style.module.css';

interface Props {
  updateData: (clientPhones: ClientPhoneData[]) => void;
  showPhoneList: boolean;
}

const PhoneList: FC<Props> = ({ updateData, showPhoneList }: Props) => {
  const dispatch = useAppDispatch();

  return (
    <div
      className={cn({
        [styles.blockContainer]: showPhoneList,
        [styles.blockContainerCenter]: showPhoneList,
        [styles.invisible]: !showPhoneList,
      })}
    >
      <Form.List
        name="clientPhones"
        initialValue={[{}]}
        rules={[
          {
            validator: async (_, clientPhones) => {
              if (!clientPhones || clientPhones.length < 1) {
                return Promise.reject(
                  new Error('Необходимо заполнить список телефонов'),
                );
              }
            },
          },
        ]}
      >
        {(fields, { add, remove }, { errors }) => (
          <div className={styles.phoneContainer}>
            <div className={styles.phoneBtnContainer}>
              <Button
                type="dashed"
                icon={<PlusOutlined />}
                className={styles.phoneBtn}
                onClick={() => add()}
              >
                Добавить
              </Button>
              <Upload
                customRequest={(option) => {
                  let formData = new FormData();
                  formData.append('file', option.file);

                  dispatch(updloadTasks(formData)).then((response) =>
                    updateData(response.payload as ClientPhoneData[]),
                  );
                }}
                itemRender={() => null}
              >
                <Button className={styles.button} icon={<UploadOutlined />}>
                  Загрузить
                </Button>
              </Upload>
            </div>
            {fields.map(({ key, name, ...restField }) => (
              <div key={key} className={styles.phoneList}>
                <div className={styles.phoneListContainer}>
                  <div className={styles.phoneListInputs}>
                    <Form.Item
                      {...restField}
                      label="ФИО:"
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 20 }}
                      name={[name, 'fullName']}
                      rules={[
                        { required: true, message: 'Необходимо указать ФИО' },
                      ]}
                      className={styles.formItem}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      label="Телефон:"
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      name={[name, 'phone']}
                      rules={[
                        {
                          required: true,
                          message: 'Необходимо указать номер телефона',
                        },
                      ]}
                      className={styles.formItem}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <Form.Item
                    {...restField}
                    name={[name, 'clientData']}
                    label="Данные:"
                    labelCol={{ span: 3 }}
                    wrapperCol={{ span: 21 }}
                  >
                    <Input />
                  </Form.Item>
                </div>
                <MinusCircleOutlined
                  className={styles.minusCircleOutlined}
                  onClick={() => remove(name)}
                />
              </div>
            ))}
            <Form.ErrorList errors={errors} />
          </div>
        )}
      </Form.List>
    </div>
  );
};

export default PhoneList;
